module.exports = __webpack_public_path__ + "static/media/logo-white.4de15244.svg";